import React, { useState } from 'react';
import Container from './Container';
import { useSEO } from '../hooks/useSEO';

const FAQ = () => {
  const [expandedItems, setExpandedItems] = useState({});
  const [searchTerm, setSearchTerm] = useState('');

  const faqCategories = [
    {
      title: 'Ξεκινώντας',
      items: [
        {
          question: 'Τι είναι το TailClinic και πώς θα βοηθήσει το ιατρείο μου;',
          answer: 'Το TailClinic είναι ένα σύγχρονο λογισμικό διαχείρισης κτηνιατρείου. Σας βοηθά να οργανώσετε τα ραντεβού σας, να κρατάτε πλήρη ψηφιακό φάκελο ασθενούς, να διαχειρίζεστε τις βάρδιες του προσωπικού και να επικοινωνείτε αυτόματα με τους πελάτες σας μέσω email υπενθυμίσεων.'
        },
        {
          question: 'Χρειάζεται να εγκαταστήσω κάποιο πρόγραμμα;',
          answer: 'Όχι, το TailClinic είναι Cloud εφαρμογή. Μπορείτε να έχετε πρόσβαση από οποιονδήποτε υπολογιστή, tablet ή κινητό, αρκεί να έχετε σύνδεση στο διαδίκτυο.'
        }
      ]
    },
    {
      title: 'Τιμολόγηση και Πλάνα',
      items: [
        {
          question: 'Τι συμβαίνει αν αναβαθμίσω το πλάνο μου;',
          answer: 'Σε περίπτωση αναβάθμισης (π.χ. από Basic σε Professional), το νέο πλάνο τίθεται σε ισχύ αμέσως για να έχετε άμεση πρόσβαση στα νέα εργαλεία. Δεν θα χρεωθείτε ξανά ολόκληρο το ποσό, παρά μόνο την αναλογική διαφορά για τις ημέρες που απομένουν μέχρι τον επόμενο κύκλο χρέωσής σας.'
        },
        {
          question: 'Τι ισχύει αν αποφασίσω να μειώσω το πλάνο μου (Downgrade);',
          answer: 'Αν επιλέξετε ένα μικρότερο πακέτο, η αλλαγή θα προγραμματιστεί να συμβεί στη λήξη του τρέχοντος κύκλου χρέωσής σας. Μέχρι τότε, θα συνεχίσετε να έχετε πρόσβαση στα χαρακτηριστικά του μεγαλύτερου πακέτου και η νέα, χαμηλότερη χρέωση θα ξεκινήσει με την έναρξη του νέου μήνα.'
        },
        {
          question: 'Πώς λειτουργεί η δωρεάν δοκιμή των 3 μηνών;',
          answer: 'Προσφέρουμε 3 μήνες πλήρους πρόσβασης (Early Access) για όλους τους νέους πελάτες. Δεν απαιτείται πιστωτική κάρτα για την εγγραφή. Μετά το πέρας των 3 μηνών, επιλέγετε το πλάνο που σας ταιριάζει για να συνεχίσετε.'
        }
      ]
    },
    {
      title: 'Διαχείριση Δεδομένων & Ασφάλεια',
      items: [
        {
          question: 'Μπορώ να διαγράψω τα δεδομένα μου;',
          answer: 'Ναι, έχετε τον πλήρη έλεγχο. Μπορείτε ανά πάσα στιγμή να επιλέξετε την οριστική διαγραφή όλων των δεδομένων του ιατρείου σας από τις ρυθμίσεις ασφαλείας. Προσοχή: αυτή η ενέργεια είναι μη αναστρέψιμη για λόγους ασφαλείας.'
        },
        {
          question: 'Είναι δυνατή η εξαγωγή (export) των δεδομένων;',
          answer: 'Προς το παρόν, η εφαρμογή δεν υποστηρίζει τη δυνατότητα μαζικής εξαγωγής δεδομένων σε εξωτερικά αρχεία. Όλες οι πληροφορίες παραμένουν αποθηκευμένες με ασφάλεια εντός της πλατφόρμας του TailClinic.'
        }
      ]
    }
  ];


useSEO({
    title: 'Συχνές Ερωτήσεις (FAQ) - TailClinic',
    description: 'Έχετε απορίες για το TailClinic; Βρείτε γρήγορα απαντήσεις για τις χρεώσεις, την ασφάλεια των ιατρικών δεδομένων και τον τρόπο λειτουργίας.',
    canonical: 'https://www.tailclinic.gr/faq',
  });


  const toggleItem = (categoryIndex, itemIndex) => {
    const key = `${categoryIndex}-${itemIndex}`;
    setExpandedItems(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const filteredCategories = faqCategories.map(category => ({
    ...category,
    items: category.items.filter(item =>
      item.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.answer.toLowerCase().includes(searchTerm.toLowerCase())
    )
  })).filter(category => category.items.length > 0);

  return (
    <section style={{
      padding: '5rem 0 6rem 0',
      backgroundColor: '#1A202C',
      minHeight: '100vh',
      position: 'relative'
    }}>
      <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(800px 800px at 10% -10%, rgba(16,185,129,0.1), transparent), radial-gradient(800px 800px at 110% 10%, rgba(59,130,246,0.05), transparent)' }} />

      <Container>
        <div style={{ textAlign: 'center', marginBottom: '3.5rem', position: 'relative' }}>
          <h1 style={{ fontSize: '3rem', fontWeight: '800', color: 'white', marginBottom: '1rem' }}>
            Συχνές <span style={{ color: '#10B981' }}>Ερωτήσεις</span>
          </h1>
          <p style={{ fontSize: '1.2rem', color: '#9CA3AF' }}>
            Απαντάμε στις απορίες σας για τη λειτουργία και τις χρεώσεις.
          </p>
        </div>

        {/* Search Bar */}
        <div style={{ maxWidth: '600px', margin: '0 auto 3rem auto', position: 'relative' }}>
          <input
            type="text"
            placeholder="Αναζήτηση..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: '100%',
              padding: '1rem 1.5rem 1rem 3.5rem',
              backgroundColor: '#111827',
              border: '1px solid #374151',
              borderRadius: '1rem',
              color: 'white',
              fontSize: '1rem',
              outline: 'none'
            }}
          />
          <svg style={{ position: 'absolute', left: '1.25rem', top: '50%', transform: 'translateY(-50%)', width: '1.2rem', height: '1.2rem', color: '#6B7280' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>

        <div style={{ maxWidth: '800px', margin: '0 auto', position: 'relative' }}>
          {filteredCategories.map((category, categoryIndex) => (
            <div key={category.title} style={{ marginBottom: '3rem' }}>
              <h2 style={{ fontSize: '1.3rem', fontWeight: '700', color: '#10B981', marginBottom: '1.2rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                {category.title}
              </h2>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
                {category.items.map((item, itemIndex) => {
                  const key = `${categoryIndex}-${itemIndex}`;
                  const isExpanded = expandedItems[key];

                  return (
                    <div key={itemIndex} style={{
                      backgroundColor: '#1F2937',
                      borderRadius: '1rem',
                      border: '1px solid #374151',
                      overflow: 'hidden'
                    }}>
                      <button
                        onClick={() => toggleItem(categoryIndex, itemIndex)}
                        style={{
                          width: '100%',
                          padding: '1.25rem 1.5rem',
                          backgroundColor: 'transparent',
                          border: 'none',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          cursor: 'pointer',
                          color: 'white',
                          fontSize: '1.05rem',
                          fontWeight: '600',
                          textAlign: 'left'
                        }}
                      >
                        <span>{item.question}</span>
                        <span style={{
                          color: '#10B981',
                          fontSize: '1.5rem',
                          transform: isExpanded ? 'rotate(45deg)' : 'rotate(0deg)',
                          transition: 'transform 0.2s'
                        }}>+</span>
                      </button>

                      {isExpanded && (
                        <div style={{
                          padding: '0 1.5rem 1.5rem 1.5rem',
                          color: '#9CA3AF',
                          fontSize: '1rem',
                          lineHeight: '1.7',
                          borderTop: '1px solid rgba(255,255,255,0.05)'
                        }}>
                          {item.answer}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default FAQ;